 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2":"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2","Accounts~CashMoviments":"Accounts~CashMoviments","Accounts":"Accounts","Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms":"Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms","CashMoviments":"CashMoviments","Orders":"Orders","OutgoingInvoices~ProductsInvoices":"OutgoingInvoices~ProductsInvoices","OutgoingInvoices":"OutgoingInvoices","ProductsInvoices":"ProductsInvoices","Company~Documents~IcommingInvoices~ProductForm":"Company~Documents~IcommingInvoices~ProductForm","IcommingInvoices":"IcommingInvoices","ImportOrders":"ImportOrders","Logistics":"Logistics","OrdersDetails":"OrdersDetails","Product":"Product","Company":"Company","ProductForm":"ProductForm","Customers":"Customers","Suppliers":"Suppliers","Users":"Users","Calendars":"Calendars","Documents":"Documents","Home":"Home","Dashboard":"Dashboard","SyncOrdersPlatforms":"SyncOrdersPlatforms","CashFlow":"CashFlow","InvoiceDetails":"InvoiceDetails","POS":"POS","Roles":"Roles","integrations":"integrations"}[chunkId]||chunkId) + "." + {"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2":"56510e92","Accounts~CashMoviments":"b471bbbb","Accounts":"c46604ab","Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms":"eb6b9cd7","CashMoviments":"816d3f69","Orders":"cce595d6","OutgoingInvoices~ProductsInvoices":"b12f871d","OutgoingInvoices":"e2f7aaa0","ProductsInvoices":"d71d5169","Company~Documents~IcommingInvoices~ProductForm":"3a9ae977","IcommingInvoices":"12368bbe","ImportOrders":"61dc6c56","Logistics":"42761bb5","OrdersDetails":"6341a577","Product":"ed1837bf","chunk-56e42126":"be2403d5","Company":"96309509","ProductForm":"c575fd02","Customers":"294d4bc2","Suppliers":"4fcac93e","Users":"63ce6202","Calendars":"0b42480d","Documents":"3dcba55c","Home":"3ccd6c5d","Dashboard":"19526d57","SyncOrdersPlatforms":"24d10148","CashFlow":"edbb88b6","InvoiceDetails":"3ac7cc14","POS":"f6c27bd6","Roles":"9d7de795","chunk-29877f9f":"bf960e1e","chunk-2c30d3cd":"af2a87f5","chunk-35e614cc":"644c13da","chunk-a9dd5b50":"492f8ad0","chunk-6eeb0879":"de99eb00","chunk-ca359154":"e309b694","chunk-571c801a":"4a26d510","chunk-572caf52":"3bd497fd","integrations":"2b8ae63f","chunk-2d0cb76d":"b37f31ff","chunk-5ef6270d":"bedcb15c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2":1,"Accounts~CashMoviments":1,"Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms":1,"CashMoviments":1,"Orders":1,"OutgoingInvoices~ProductsInvoices":1,"OutgoingInvoices":1,"ProductsInvoices":1,"Company~Documents~IcommingInvoices~ProductForm":1,"IcommingInvoices":1,"ImportOrders":1,"Logistics":1,"OrdersDetails":1,"Product":1,"Company":1,"ProductForm":1,"Customers":1,"Suppliers":1,"Users":1,"Calendars":1,"Documents":1,"Home":1,"POS":1,"chunk-29877f9f":1,"chunk-2c30d3cd":1,"chunk-35e614cc":1,"chunk-a9dd5b50":1,"chunk-6eeb0879":1,"chunk-ca359154":1,"chunk-571c801a":1,"chunk-572caf52":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2":"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2","Accounts~CashMoviments":"Accounts~CashMoviments","Accounts":"Accounts","Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms":"Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms","CashMoviments":"CashMoviments","Orders":"Orders","OutgoingInvoices~ProductsInvoices":"OutgoingInvoices~ProductsInvoices","OutgoingInvoices":"OutgoingInvoices","ProductsInvoices":"ProductsInvoices","Company~Documents~IcommingInvoices~ProductForm":"Company~Documents~IcommingInvoices~ProductForm","IcommingInvoices":"IcommingInvoices","ImportOrders":"ImportOrders","Logistics":"Logistics","OrdersDetails":"OrdersDetails","Product":"Product","Company":"Company","ProductForm":"ProductForm","Customers":"Customers","Suppliers":"Suppliers","Users":"Users","Calendars":"Calendars","Documents":"Documents","Home":"Home","Dashboard":"Dashboard","SyncOrdersPlatforms":"SyncOrdersPlatforms","CashFlow":"CashFlow","InvoiceDetails":"InvoiceDetails","POS":"POS","Roles":"Roles","integrations":"integrations"}[chunkId]||chunkId) + "." + {"Accounts~CashMoviments~Company~Customers~IcommingInvoices~ImportOrders~Logistics~Orders~OrdersDetail~31b989f2":"d5ffd80c","Accounts~CashMoviments":"9f442fd2","Accounts":"31d6cfe0","Calendars~CashMoviments~Dashboard~Documents~Home~Orders~OutgoingInvoices~ProductsInvoices~SyncOrdersPlatforms":"7c8dcfe4","CashMoviments":"dbb19938","Orders":"2911b57a","OutgoingInvoices~ProductsInvoices":"0d6fcf62","OutgoingInvoices":"de69a111","ProductsInvoices":"4017d4ed","Company~Documents~IcommingInvoices~ProductForm":"8e30ca96","IcommingInvoices":"932ffe60","ImportOrders":"fe2ef7e4","Logistics":"3d8b0be1","OrdersDetails":"54832988","Product":"2911b57a","chunk-56e42126":"31d6cfe0","Company":"50d49d43","ProductForm":"f0895670","Customers":"1e0427bb","Suppliers":"1e0427bb","Users":"3d8b0be1","Calendars":"40759497","Documents":"ed7de563","Home":"9a7ba621","Dashboard":"31d6cfe0","SyncOrdersPlatforms":"31d6cfe0","CashFlow":"31d6cfe0","InvoiceDetails":"31d6cfe0","POS":"34bcb317","Roles":"31d6cfe0","chunk-29877f9f":"eabf8d7c","chunk-2c30d3cd":"ff3d539c","chunk-35e614cc":"9ebd2976","chunk-a9dd5b50":"9f12c73b","chunk-6eeb0879":"a5ab674d","chunk-ca359154":"62995ec1","chunk-571c801a":"ff3d539c","chunk-572caf52":"584f3b97","integrations":"31d6cfe0","chunk-2d0cb76d":"31d6cfe0","chunk-5ef6270d":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
